import React, { useContext } from "react";
import { ExpandableContainer } from "@bloomberg/media-ui-markets";
import { ScreenContext } from "@foundation/screen";
import styles from "./BoardMembersContainer.module.css";
import { BoardMemberData } from "~types/types";
import { useTranslateMessage } from "~utils/i18n";

export type BoardMembersProps = {
  boardMembers: BoardMemberData[];
};

export default function BoardMembersContainer(props: BoardMembersProps) {
  const {
    breakpoints: { tablet, smallDesktop },
  } = useContext(ScreenContext);
  const { boardMembers } = props;

  const translateMessage = useTranslateMessage();
  const boardMemberTitle = `${translateMessage({
    id: "boardMembers",
    defaultMessage: "Board Members",
  })} `;

  let displayCount = 3;

  if (!boardMembers?.length) {
    return null;
  }

  if (smallDesktop) {
    displayCount = 6;
  } else if (tablet) {
    displayCount = 4;
  } else {
    displayCount = 3;
  }

  return (
    <ExpandableContainer
      className={styles.boardMembers}
      containerTitle={`${boardMemberTitle}`}
      people={boardMembers}
      showCompany
      displayedRowsCount={displayCount}
    />
  );
}
